

import React, { memo, useCallback, useContext, useMemo } from 'react';
import AppleSignin from 'react-apple-signin-auth';
import { SOCIAL_TYPE } from '@shootsta/common-domain-data';
import globalConfig from 'react-global-configuration';
import { appleAuthOptions } from '../constants/appleAuthOptions';
import { SocialAuthButtonListContext } from '../context/SocialAuthButtonListContext';
import { getSocialAuthAppleIdToken } from '../utils/socialAuthApple';
import SocialAuthButton from './SocialAuthButton';



const type = SOCIAL_TYPE.APPLE;

const SocialAuthButtonApple = () => {
  const authOptions = useMemo(() => ({
    clientId: globalConfig.get('socialAppleClientId'),
    ...appleAuthOptions
  }), []);

  const { onAuthSuccess, onAuthError } = useContext(SocialAuthButtonListContext);

  const onSuccess = useCallback(async (data) => {
    onAuthSuccess({ type, token: getSocialAuthAppleIdToken(data) });
  }, [onAuthSuccess]);

  const onError = useCallback(() => {
    onAuthError();
  }, [onAuthError]);

  const onRender = useCallback(({ onClick }) =>
  <SocialAuthButton
    type={type}
    onClick={onClick} />,


  []);

  return (
    <AppleSignin
      authOptions={authOptions}
      onSuccess={onSuccess}
      onError={onError}
      render={onRender} />);


};

export default memo(SocialAuthButtonApple);